// eslint-disable-next-line max-classes-per-file
import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';

class MyError extends Error {
  errorExtraParamsGet;

  constructor(message: any, errorExtraParams: any) {
    super(message);
    this.errorExtraParamsGet = errorExtraParams;
  }

  get errorExtraParams() {
    return this.errorExtraParamsGet;
  }
}

export class CellService {
  static prefix = '/Cell';

  public static async postCellSett(body: any) {
    const url = `${CellService.prefix}/Setting`;

    try {
      const response: AxiosResponse = await axios.post(url, body);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }
}
